import React from "react";
import { Stack } from "@mui/system";
import { ButtonMGPrimary } from "./ButtonMGPrimary";
import { useNavigate } from "react-router-dom";

export default function ButtonsStep({
  createPayment,
  nextStep,
  previousStep,
  formStep,
  invalidState,
  returnUrl,
}: any) {
  const navigate = useNavigate();

  return (
    <Stack direction={"row"}>
      {formStep === 0 && (
        <ButtonMGPrimary
          title="Salir"
          action={() => navigate(returnUrl)} // <--- navegamos a la URL que venga
        />
      )}
      {formStep !== 0 && (
        <ButtonMGPrimary
          title="Volver"
          action={previousStep}
          disabled={formStep === 0}
        />
      )}

      {formStep !== 3 && (
        <ButtonMGPrimary
          title="Siguiente"
          action={nextStep}
          disabled={invalidState}
        />
      )}
      {formStep === 3 && (
        <ButtonMGPrimary
          title="Finalizar"
          action={createPayment}
          disabled={invalidState}
        />
      )}
    </Stack>
  );
}
